import NeoparentHome from "@/components/NeoparentHome";
import NeoparentPatientSelector from "@/components/NeoparentPatientSelector";
import NeoparentWebcam from "@/components/NeoparentWebcam";
import NeoparentVisit from "@/components/NeoparentVisit";
import NeoparentNotifications from "@/components/NeoparentNotifications";
import NeoparentMenu from "@/components/NeoparentMenu";
import NeoparentPrint from "@/components/NeoparentPrint";
import NeoparentHospital from "@/components/NeoparentHospital";
import MediligoProductionCheck from "@/components/MediligoProductionCheck";
import NeoparentUnlicensed from "@/components/NeoparentUnlicensed";
import neoparentDownload from "@/components/NeoparentDownload";
import NeoparentSessExp from "@/components/NeoparentSessExp";
import NeoparentUnauthorized from "@/components/NeoparentUnauthorized";
import NeoparentNoParentConsent from "@/components/NeoparentNoParentConsent.vue";
import NeoparentLoggedOut from "@/components/NeoparentLoggedOut.vue";
import NeoparentTiptap from "@/components/NeoparentTiptap";
import NeoparentConsentDenied from "@/components/NeoparentConsentDenied.vue";
// Posts
import NeoparentCreatePost from "@/components/NeoparentCreatePost";
import NeoparentCreateReflection from "@/components/NeoparentCreateReflection";
import SelectPostType from "@/components/SelectPostType";
// Settings
import NeoparentSettings from "@/components/NeoparentSettings";
import NeoparentAbout from "@/components/settings/NeoparentAbout";
import NeoparentAccess from "@/components/settings/NeoparentAccess";
import NeoparentFaq from "@/components/settings/NeoparentFaq";
import NeoparentFeedback from "@/components/settings/NeoparentFeedback";
import NeoparentLanguage from "@/components/settings/NeoparentLanguage";
import NeoparentReportProblem from "@/components/settings/NeoparentReportProblem";
import NeoparentEditProfile from "@/components/settings/NeoparentEditProfile";
// Profile
import NeoparentGallery from "@/components/profile/NeoparentGallery";
import NeoparentEvolution from "@/components/profile/NeoparentEvolution";
import NeoparentMilestones from "@/components/profile/NeoparentMilestones";
import NeoparentDictionary from "@/components/profile/NeoparentDictionary";
// Dashboard
import NeoparentDashboardHome from "@/components/dashboard/NeoparentDashboardHome";
import NeoparentNurses from "@/components/dashboard/NeoparentNurses";
import NeoparentCreateNurse from "@/components/dashboard/NeoparentCreateNurse";
import NeoparentPatients from "@/components/dashboard/NeoparentPatients";
import NeoparentCreatePatient from "@/components/dashboard/NeoparentCreatePatient";
import NeoparentCreatePatientEpd from "@/components/dashboard/NeoparentCreatePatientEpd";
import NeoparentHospitalInfo from "@/components/dashboard/NeoparentHospitalInfo";
import NeoparentLexicon from "@/components/dashboard/NeoparentLexicon";
import NeoparentCreateLexiconEntry from "@/components/dashboard/NeoparentCreateLexiconEntry";
import NeoparentTags from "@/components/dashboard/NeoparentTags";
import NeoparentNewParent from "@/components/dashboard/NeoparentNewParent";
import NeoparentVisits from "@/components/dashboard/NeoparentVisits";
import NeoparentPosts from "@/components/dashboard/NeoparentPosts";
import NeoparentCreateChecklist from "@/components/dashboard/NeoparentCreateChecklist";
import NeoparentMessageConfiguration from "@/components/dashboard/NeoparentMessageConfiguration";
import NeoparentStatistics from "@/components/dashboard/NeoparentStatistics";
import NeoparentDashboardProfile from "@/components/dashboard/NeoparentDashboardProfile.vue";
// Auth
import NeoparentForgotPass from "@/components/auth/NeoparentForgotPass";
import NeoparentChangePass from "@/components/auth/NeoparentChangePass";
import NeoparentNewProfile from "@/components/auth/NeoparentNewProfile";
import NeoparentNewAccess from "@/components/auth/NeoparentNewAccess";
import NeoparentLogin from "@/components/auth/NeoparentLogin";
import NeoparentMagicLinkError from "@/components/auth/NeoparentMagicLinkError";
import NeoparentVisitOverview from "@/components/NeoparentVisitOverview";
import NeoparentActivationCode from "@/components/auth/neoparentActivationCode.vue";
import NeoparentReadmit from "@/components/dashboard/NeoparentReadmit.vue";
import NeoparentTranslationLanguage from "@/components/settings/NeoparentTranslationLanguage.vue";
import NeoparentShadowDictionary from "@/components/dashboard/NeoparentShadowDictionary.vue";
import NeoparentShadowTags from "@/components/dashboard/NeoparentShadowTags.vue";
import LoadingOverlay from "@/components/LoadingOverlay.vue";


const ManagerPlugin = {
  install(Vue) {
    Vue.component(NeoparentHome.name, NeoparentHome);
    Vue.component(NeoparentPrint.name, NeoparentPrint);
    Vue.component(NeoparentPatientSelector.name, NeoparentPatientSelector);
    Vue.component(NeoparentWebcam.name, NeoparentWebcam);
    Vue.component(NeoparentVisit.name, NeoparentVisit);
    Vue.component(NeoparentNotifications.name, NeoparentNotifications);
    Vue.component(NeoparentMenu.name, NeoparentMenu);
    Vue.component(NeoparentHospital.name, NeoparentHospital);
    Vue.component(NeoparentVisitOverview.name, NeoparentVisitOverview);
    Vue.component(MediligoProductionCheck.name, MediligoProductionCheck);
    Vue.component(NeoparentUnlicensed.name, NeoparentUnlicensed);
    Vue.component(neoparentDownload.name, neoparentDownload);
    Vue.component(NeoparentSessExp.name, NeoparentSessExp);
    Vue.component(NeoparentUnauthorized.name, NeoparentUnauthorized);
    Vue.component(NeoparentNoParentConsent.name, NeoparentNoParentConsent);
    Vue.component(NeoparentLoggedOut.name, NeoparentLoggedOut);
    Vue.component(NeoparentTiptap.name, NeoparentTiptap);
    Vue.component(NeoparentConsentDenied.name, NeoparentConsentDenied);
    // Posts
    Vue.component(NeoparentCreatePost.name, NeoparentCreatePost);
    Vue.component(NeoparentCreateReflection.name, NeoparentCreateReflection);
    Vue.component(SelectPostType.name, SelectPostType);
    // Settings
    Vue.component(NeoparentSettings.name, NeoparentSettings);
    Vue.component(NeoparentAbout.name, NeoparentAbout);
    Vue.component(NeoparentAccess.name, NeoparentAccess);
    Vue.component(NeoparentFaq.name, NeoparentFaq);
    Vue.component(NeoparentFeedback.name, NeoparentFeedback);
    Vue.component(NeoparentLanguage.name, NeoparentLanguage);
    Vue.component(NeoparentReportProblem.name, NeoparentReportProblem);
    Vue.component(NeoparentEditProfile.name, NeoparentEditProfile);
    // Profile
    Vue.component(NeoparentGallery.name, NeoparentGallery);
    Vue.component(NeoparentEvolution.name, NeoparentEvolution);
    Vue.component(NeoparentMilestones.name, NeoparentMilestones);
    Vue.component(NeoparentDictionary.name, NeoparentDictionary);
    // Dashboard
    Vue.component(NeoparentReadmit.name, NeoparentReadmit)
    Vue.component(NeoparentDashboardHome.name, NeoparentDashboardHome);
    Vue.component(NeoparentNurses.name, NeoparentNurses);
    Vue.component(NeoparentCreateNurse.name, NeoparentCreateNurse);
    Vue.component(NeoparentPatients.name, NeoparentPatients)
    Vue.component(NeoparentCreatePatient.name, NeoparentCreatePatient);
    Vue.component(NeoparentCreatePatientEpd.name, NeoparentCreatePatientEpd);
    Vue.component(NeoparentHospitalInfo.name, NeoparentHospitalInfo);
    Vue.component(NeoparentLexicon.name, NeoparentLexicon);
    Vue.component(NeoparentCreateLexiconEntry.name, NeoparentCreateLexiconEntry);
    Vue.component(NeoparentTags.name, NeoparentTags);
    Vue.component(NeoparentNewParent.name, NeoparentNewParent);
    Vue.component(NeoparentVisits.name, NeoparentVisits);
    Vue.component(NeoparentPosts.name, NeoparentPosts);
    Vue.component(NeoparentCreateChecklist.name, NeoparentCreateChecklist);
    Vue.component(NeoparentMessageConfiguration.name, NeoparentMessageConfiguration);
    Vue.component(NeoparentStatistics.name, NeoparentStatistics);
    Vue.component(NeoparentDashboardProfile.name, NeoparentDashboardProfile);
    // Auth
    Vue.component(NeoparentForgotPass.name, NeoparentForgotPass);
    Vue.component(NeoparentChangePass.name, NeoparentChangePass);
    Vue.component(NeoparentNewProfile.name, NeoparentNewProfile);
    Vue.component(NeoparentNewAccess.name, NeoparentNewAccess);
    Vue.component(NeoparentLogin.name, NeoparentLogin);
    Vue.component(NeoparentMagicLinkError.name, NeoparentMagicLinkError);
    Vue.component(NeoparentActivationCode.name, NeoparentActivationCode);

    Vue.component(NeoparentTranslationLanguage.name, NeoparentTranslationLanguage);
    Vue.component(NeoparentShadowDictionary.name, NeoparentShadowDictionary);
    Vue.component(NeoparentShadowTags.name, NeoparentShadowTags);
    // Shared UI primitives
    Vue.component(LoadingOverlay.name, LoadingOverlay);
  }
};

export { ManagerPlugin };
